import dayjs from 'dayjs'

import storage from '@/services/storage/localStorage'
import token from '@/constants/token'

export default {
  dayjs,
  event: ['input', 'click', 'wheel', 'ontouchstart', 'touchmove'],
  tokenExpirationHeader: token.TOKEN_EXPIRATION_HEADER_NAME,

  refreshInterval: {
    interval: null,
    intervalTimeout: 10000
  },
  startRefreshInterval(handler) {
    this.refreshInterval.interval = setInterval(() => {
      /*
       * do nothing, there is no valid token to refresh
       */
      if (this.isTokenValid() === false) {
        return
      }

      /*
       * do nothing, user is inactive for more than specified timeout
       */
      if (this.isInactivityTimeoutExceeded() === true) {
        return
      }

      /*
       * do nothing, token has more time to live than refresh trigger
       */
      if (this.shouldRefreshToken() === false) {
        return
      }

      handler()
    }, this.refreshInterval.intervalTimeout)
  },

  // logout user if do not met token requirements (i.e. isInactivityTimeoutExceeded)
  tokenGuardInterval: {
    interval: null,
    intervalTimeout: 1000
  },
  startTokenGuardInterval(logoutCallback, inactivityCallback) {
    this.tokenGuardInterval.interval = setInterval(() => {
      if (this.isInactivityTimeoutExceeded() || this.isTokenValid() === false) {
        logoutCallback()
      }

      if (this.shouldShowInactivityModal()) {
        inactivityCallback(true, this.getTimeToLogout())
      } else {
        inactivityCallback(false, 0)
      }
    }, this.tokenGuardInterval.intervalTimeout)
  },

  // last activity event listeners
  listeners() {
    this.event.forEach((event) => {
      window.addEventListener(event, () => {
        this.setLastActivityTimestamp(dayjs().unix())
      })
    })
  },

  removeAll() {
    clearInterval(this.refreshInterval.interval)
    this.refreshInterval.interval = null
    clearInterval(this.tokenGuardInterval.interval)
    this.tokenGuardInterval.interval = null
    storage.delete(token.TOKEN_EXPIRATION_KEY)
    storage.delete(token.LAST_ACTIVITY_TIMESTAMP_KEY)
  },

  // Expiration timestamp
  getTokenExpirationTimestamp() {
    const timestamp = parseInt(storage.get(token.TOKEN_EXPIRATION_KEY), 10)

    return Number.isNaN(timestamp) ? 0 : timestamp
  },
  setTokenExpirationTimestamp(timestamp) {
    storage.set(token.TOKEN_EXPIRATION_KEY, timestamp.toString())

    return this
  },

  // last activity
  getLastActivityTimestamp() {
    const timestamp = parseInt(storage.get(token.LAST_ACTIVITY_TIMESTAMP_KEY), 10)

    return Number.isNaN(timestamp) ? 0 : timestamp
  },
  setLastActivityTimestamp(timestamp) {
    storage.set(token.LAST_ACTIVITY_TIMESTAMP_KEY, timestamp.toString())

    return this
  },

  // getters
  getTokenTtl() {
    const currentTimestamp = dayjs().unix()
    const ttl = this.getTokenExpirationTimestamp() - currentTimestamp

    return ttl < 0 ? 0 : ttl
  },
  getInactivityTime() {
    return dayjs().unix() - this.getLastActivityTimestamp()
  },
  getTimeToLogout() {
    return token.INACTIVITY_TIME_LIMIT - this.getInactivityTime()
  },
  isTokenValid() {
    return this.getTokenTtl() > 0
  },
  getTokenMaxTtl() {
    return token.TOKEN_MAX_TTL
  },
  shouldRefreshToken() {
    return this.getTokenTtl() < this.getTokenMaxTtl() - token.TOKEN_TTL_REFRESH_TRIGGER
  },
  shouldShowInactivityModal() {
    return this.isTokenValid() && this.getInactivityTime() >= token.INACTIVITY_TIME_MODAL_TRIGGER
  },
  isInactivityTimeoutExceeded() {
    return this.getInactivityTime() >= token.INACTIVITY_TIME_LIMIT
  }
}
